import { render, staticRenderFns } from "./AppDiagnosticInfo.vue?vue&type=template&id=1f065ff6&scoped=true&"
import script from "./AppDiagnosticInfo.vue?vue&type=script&lang=js&"
export * from "./AppDiagnosticInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppDiagnosticInfo.vue?vue&type=style&index=0&id=1f065ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f065ff6",
  null
  
)

export default component.exports